// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
}

.modal-content {
    background: white;
    border-radius: 10px;
    width: 90%;
    max-width: 600px;
    max-height: 90vh;
    overflow-y: auto;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
}

.modal-header {
    padding: 20px 30px;
    border-bottom: 1px solid #eee;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.modal-header h2 {
    margin: 0;
    color: #333;
    font-size: 20px;
}

.close-btn {
    background: none;
    border: none;
    font-size: 32px;
    color: #999;
    cursor: pointer;
    padding: 0;
    width: 32px;
    height: 32px;
    line-height: 1;
}

.close-btn:hover {
    color: #333;
}

.modal-content form {
    padding: 30px;
}

.modal-content .form-group {
    margin-bottom: 20px;
}

.modal-content .form-group label {
    display: block;
    margin-bottom: 8px;
    color: #555;
    font-weight: 600;
    font-size: 14px;
}

.modal-content .form-group input,
.modal-content .form-group select {
    width: 100%;
    padding: 10px;
    border: 1px solid #ddd;
    border-radius: 5px;
    font-size: 14px;
    box-sizing: border-box;
}

.modal-content .form-group input:focus,
.modal-content .form-group select:focus {
    outline: none;
    border-color: #667eea;
}

.modal-content .form-group small {
    display: block;
    margin-top: 4px;
    color: #666;
    font-size: 12px;
}

.checkbox-group label {
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
}

.checkbox-group input[type="checkbox"] {
    width: auto;
    margin: 0;
}

.modal-footer {
    padding: 20px 30px;
    border-top: 1px solid #eee;
    display: flex;
    gap: 10px;
    background: #f8f9fa;
}

.modal-footer button {
    flex: 1 1;
}

.success {
    background: #d4edda;
    color: #155724;
    padding: 12px;
    border-radius: 5px;
    margin-bottom: 20px;
    font-size: 14px;
}

.customer-list {
    max-height: 200px;
    overflow-y: auto;
    border: 1px solid #ddd;
    border-radius: 5px;
    padding: 10px;
    background: #fafafa;
}

.customer-item {
    margin-bottom: 10px;
}

.customer-item:last-child {
    margin-bottom: 0;
}

.customer-item label {
    display: flex;
    align-items: center;
    cursor: pointer;
    font-weight: normal !important;
    padding: 5px;
    border-radius: 3px;
    transition: background 0.2s;
}

.customer-item label:hover {
    background: #e8e8e8;
}

.customer-item input[type="checkbox"] {
    width: auto !important;
    margin: 0 10px 0 0 !important;
    cursor: pointer;
}

.customer-item span {
    flex: 1 1;
}
`, "",{"version":3,"sources":["webpack://./src/components/ScannerConfigModal.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,0CAA0C;AAC9C;;AAEA;IACI,kBAAkB;IAClB,6BAA6B;IAC7B,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,WAAW;IACX,eAAe;IACf,UAAU;IACV,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,eAAe;AACnB;;AAEA;;IAEI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,sBAAsB;AAC1B;;AAEA;;IAEI,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,0BAA0B;IAC1B,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,8BAA8B;IAC9B,YAAY;IACZ,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,6BAA6B;IAC7B,eAAe;AACnB;;AAEA;IACI,SAAO;AACX","sourcesContent":[".modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0, 0, 0, 0.5);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 1000;\n}\n\n.modal-content {\n    background: white;\n    border-radius: 10px;\n    width: 90%;\n    max-width: 600px;\n    max-height: 90vh;\n    overflow-y: auto;\n    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);\n}\n\n.modal-header {\n    padding: 20px 30px;\n    border-bottom: 1px solid #eee;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.modal-header h2 {\n    margin: 0;\n    color: #333;\n    font-size: 20px;\n}\n\n.close-btn {\n    background: none;\n    border: none;\n    font-size: 32px;\n    color: #999;\n    cursor: pointer;\n    padding: 0;\n    width: 32px;\n    height: 32px;\n    line-height: 1;\n}\n\n.close-btn:hover {\n    color: #333;\n}\n\n.modal-content form {\n    padding: 30px;\n}\n\n.modal-content .form-group {\n    margin-bottom: 20px;\n}\n\n.modal-content .form-group label {\n    display: block;\n    margin-bottom: 8px;\n    color: #555;\n    font-weight: 600;\n    font-size: 14px;\n}\n\n.modal-content .form-group input,\n.modal-content .form-group select {\n    width: 100%;\n    padding: 10px;\n    border: 1px solid #ddd;\n    border-radius: 5px;\n    font-size: 14px;\n    box-sizing: border-box;\n}\n\n.modal-content .form-group input:focus,\n.modal-content .form-group select:focus {\n    outline: none;\n    border-color: #667eea;\n}\n\n.modal-content .form-group small {\n    display: block;\n    margin-top: 4px;\n    color: #666;\n    font-size: 12px;\n}\n\n.checkbox-group label {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    cursor: pointer;\n}\n\n.checkbox-group input[type=\"checkbox\"] {\n    width: auto;\n    margin: 0;\n}\n\n.modal-footer {\n    padding: 20px 30px;\n    border-top: 1px solid #eee;\n    display: flex;\n    gap: 10px;\n    background: #f8f9fa;\n}\n\n.modal-footer button {\n    flex: 1;\n}\n\n.success {\n    background: #d4edda;\n    color: #155724;\n    padding: 12px;\n    border-radius: 5px;\n    margin-bottom: 20px;\n    font-size: 14px;\n}\n\n.customer-list {\n    max-height: 200px;\n    overflow-y: auto;\n    border: 1px solid #ddd;\n    border-radius: 5px;\n    padding: 10px;\n    background: #fafafa;\n}\n\n.customer-item {\n    margin-bottom: 10px;\n}\n\n.customer-item:last-child {\n    margin-bottom: 0;\n}\n\n.customer-item label {\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n    font-weight: normal !important;\n    padding: 5px;\n    border-radius: 3px;\n    transition: background 0.2s;\n}\n\n.customer-item label:hover {\n    background: #e8e8e8;\n}\n\n.customer-item input[type=\"checkbox\"] {\n    width: auto !important;\n    margin: 0 10px 0 0 !important;\n    cursor: pointer;\n}\n\n.customer-item span {\n    flex: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
